var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVerify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25016 5.99989L5.41683 7.16655L7.75016 4.83321M10.6668 5.99989C10.6668 8.6022 7.48183 10.4879 6.37431 11.065C6.25455 11.1274 6.19465 11.1586 6.11158 11.1748C6.04683 11.1874 5.9535 11.1874 5.88875 11.1748C5.80568 11.1586 5.74577 11.1274 5.62601 11.065C4.51847 10.4879 1.3335 8.6022 1.3335 5.99989V3.79348C1.3335 3.3271 1.3335 3.09391 1.40977 2.89346C1.47715 2.71638 1.58665 2.55838 1.7288 2.43311C1.8897 2.2913 2.10805 2.20943 2.54473 2.04567L5.67245 0.872778C5.79372 0.827301 5.85433 0.804563 5.91675 0.795545C5.97205 0.787553 6.02828 0.787553 6.08358 0.795545C6.146 0.804563 6.2066 0.827301 6.32788 0.872778L9.4556 2.04567C9.89228 2.20943 10.1106 2.2913 10.2715 2.43311C10.4137 2.55838 10.5232 2.71638 10.5905 2.89346C10.6668 3.09391 10.6668 3.3271 10.6668 3.79348V5.99989Z",
    stroke: "#10A37F",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerify);
export default __webpack_public_path__ + "static/media/icon-verify.8a02c1d9084414baa210e1bf3b5d1380.svg";
export { ForwardRef as ReactComponent };